// import LayoutNews from "@/layouts/LayoutNews";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/zuzhijigou",
  name: "zuzhijigou",
  meta: {
    title: "组织机构",
    icon: require('@/assets/images/icons/zuzhi.png')
  },
  component: () => import("@/views/zuzhijigou/index.vue"),
  // component: LayoutNews,
  // redirect: "/zuzhijigou/lingdao",
  children: [
    {
      path: "/zuzhijigou/lingdao",
      name: "zhongxinlingdao",
      meta: {
        title: "中心领导",
        icon: require('@/assets/images/icons/zuzhi.png')
      },
      component: () => import("@/views/zuzhijigou/components/lingdao.vue"),
    },
    {
      path: "/zuzhijigou/zhongxinZhize",
      name: "zhongxinZhize",
      meta: {
        title: "中心职责",
        icon: require('@/assets/images/icons/zuzhi.png')
      },
      component: () => import("@/views/zuzhijigou/components/zhongxinZhize.vue"),
    },
    {
      path: "/zuzhijigou/jiguanchushi",
      name: "jiguanchushi",
      meta: {
        title: "机关处室",
        icon: require('@/assets/images/icons/zuzhi.png')
      },
      component: () => import("@/views/zuzhijigou/components/jiguanchushi.vue"),
    },
    {
      path: "/zuzhijigou/zhuyaozhize",
      name: "zhuyaozhize",
      meta: {
        title: "处室职责", // 主要职责
        icon: require('@/assets/images/icons/zuzhi.png')
      },
      component: () => import("@/views/zuzhijigou/components/zhuyaozhize.vue"),
    },
    {
      path: "/zuzhijigou/zhishudanwei",
      name: "zhishudanwei",
      meta: {
        title: "直属单位",
        icon: require('@/assets/images/icons/zuzhi.png')
      },
      component: () => import("@/views/zuzhijigou/components/zhishudanwei.vue"),
    },
  ],
}, {
  path: "/zuzhijigou-detail",
  name: "zuzhijigou-detail",
  meta: {
    title: "组织机构",
    hidden: true,
    icon: require('@/assets/images/icons/zuzhi.png')
  },
  component: LayoutArticle,
  redirect: "/zuzhijigou/detail",
  children: [{
    path: "/zuzhijigou/detail",
    name: "zuzhijigou_detail",
    meta: {
      title: "文章详情",
      hidden: true,
    },
    component: () => import("@/views/zuzhijigou/detail.vue"),
  },],
},]